import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.innerHTML = this.element.textContent.replace(
      /\S+/g,
      (word) =>
        `<span class="word" data-action="click->word-selector#select">${word}</span>`
    );
  }

  select({ currentTarget }) {
    currentTarget.classList.toggle("selected");
  }

  disconnect() {
    this.element.removeEventListener("click", this.selectWord);
  }

  selectWord = (event) => {
    if (!event.target.classList.contains("word")) return;

    event.target.classList.toggle("selected");
  };
}